
// HTML 5 VIDEO
$('.html5-video-trigger').click(function(){
    var video = $("#"+$(this).attr('data-video'));
    video = video.get(0);
    video.pause();
    if ($(this).hasClass('paused')) {
        video.play();
        $('.html5-video-trigger').removeClass('paused');
    } else {
        video.pause();
        $('.html5-video-trigger').addClass('paused');
    }
    $(this).hide();
    $(this).siblings('.html5-video-trigger').show();
});

$('.pattern').on('click', '.homepage-sidebar-trigger a', function(env){
    env.preventDefault();
    var navTarget = $(this).parents('li').attr('data-trigger');
    $('#shopify-section-homepage-sidebar ul').hide();
    $('#'+navTarget).show();
    $('li.homepage-sidebar-trigger').removeClass('active-sidebar');
    
    $('li[data-trigger="'+navTarget+'"]').addClass('active-sidebar');
})

$('.sidebar-container-trigger').on('click', 'a.open-submegamenu', function(env){
    env.preventDefault();
    //remove all other element state
    $('.sidebar-container-trigger li').removeClass('active');

    var navTarget = '#header-phantom .'+$(this).attr('data-trigger');
    $(this).parents('.sticked-sidebar').addClass('open-submegamenu-activated')
    $(this).parents('li.list-menu-sidebar').addClass('active');
    console.log($(navTarget));
    
    if (!$(this).hasClass('megamun-inserted')) {
        $(navTarget).insertAfter($(this));
        $(this).addClass('megamun-inserted')
    }
    var elementWidth = $('body').width() - 250;
    $('.linklist-groupping').css('width', elementWidth+'px');
})


$("#playyoutube").on("click", (function (t) {
    $("#youtube-video")[0].src += "&autoplay=1", $(".tp-parallax-wrap").fadeOut(600, "linear", (function () {
        $(".youtube-still").addClass("playing")
    })), t.preventDefault()
}));

// FOR PARALLAX SO THAT IT WILL NOT BREAK WHEN RESIZE AND LOAD
var timer;
$(window).bind('resize', function() {
    clearTimeout(timer);
    timer = setTimeout(function() { $(window).resize(); }, 250);
});
var timer;
$(window).bind('load', function() {
    clearTimeout(timer);
    timer = setTimeout(function() { $(window).load(); }, 250);
});

// Navigation
function displayChildMenu(src, el){
    var target = $(".display_"+src);
    if (target.length != 0) {
        var trigger = $(".trigger_"+src);
        $(el).parents('li').siblings().removeClass('activated');
        trigger.addClass('activated');
        //console.log(target.length);

        $(el).parents('.content').find('.linklist-groupping').removeClass('visible');
        target.addClass('visible');
        return false;
    }
}
$('.heading-sub-menu').click(function(){
    $('.content-submenu').removeClass('activated');
    $(this).parents('.content-submenu').addClass('activated');
    //$('.sticked-sidebar').addClass('open-submegamenu-activated');
});

 
// PRODUCTS PAGE
$('.trigger-delivery-info').click(function(){
    $(this).toggleClass('active');
    var target = $(this).attr('data-target');

    $('.delivery-info.'+target).toggleClass('hide');
    $('.delivery-info:not(.'+target+')').addClass('hide');
    $('.trigger-delivery-info').not(this).removeClass('active');
});


// Assembly services on every pdp
$(document).on("click", "#productAddAssembly", function() {
    var y = $('.productaddassembly-text'),
        S = $('#form-productAddAssembly'),
        U = $('#cart-product-assembly'),
        id = U.attr('data-key');
    if (U.hasClass('in-cart')) {
        return $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity="+0+"&id="+id,
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("REMOVING...");
            },
            success: function(E) {
                $(".product-assembly-msg").text("REMOVED");
                setTimeout(function(){ $(".product-assembly-msg").hide() }, 1000);
                U.removeClass('in-cart');
            },
            error: function(E) {
                console.log(E);
            }
        })
    } else {
        return $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            cache: !1,
            data: S.serialize(),
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("ADDING...");
            },
            complete: function() {
                $(".product-assembly-msg").text("ADDED");
                U.prop('checked', true);
                U.addClass('in-cart');
            },
            error: function(T) {
                console.log(T)
            },
            success: function(T) {
                U.attr('data-key', T.key)
            }
        }).done(function() {}), !1
    }
})

// Postage calculator #01 (typing...)
$(document).ready(function() {
    $('input#postcode1').val('');
  $('input#postcode1').keyup(function(e){  
    var txtInput = $(this).val();
    if (txtInput.length > 2){
      $('#suburb').css('height', 'auto');
      $('#suburb').slideDown();
      $('#suburb').addClass('active');
      $('#suburb ul').html('');
      $('#suburb  .spinner').show(); 
      e.preventDefault();
      $.ajax({
        url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=713&deploy=1&compid=1117015&ns-at=AAEJ7tMQEHiNlvu41bPcPH-Klcl0BC-WPko6HsiOAER-WqJ5IqE&q="+txtInput,
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp"
      })
      .done(function (data) {
        $('#suburb ul').html('');
        if (data.localities == "") {
          $('#suburb .spinner').hide();
          $('#suburb ul').append('<li><strong>Not Found</strong></li>')
        } else {
          displaySuburb(data.localities.locality);
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus + '; ' + errorThrown);
      })
    } else {
      $('#suburb').removeClass('active');
    }
  });
});

function isObject (value) {return value && typeof value === 'object' && value.constructor === Object;}

// Postage calculator #02 (display suburb)
function displaySuburb(data) {
  $('#suburb .spinner').show();
  if (isObject(data)) {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    $('#suburb ul').append('<li><strong>'+data.location+'</strong>, '+data.state+', '+data.postcode+'</li>')
  } else {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    for (var i = 0; i < data.length; i++) {
      $('#suburb ul').append('<li><strong>'+data[i].location+'</strong>, '+data[i].state+', '+data[i].postcode+'</li>')
    }
  }
}

// Postage calculator #03 (get suburb)
$("#suburb ul").on('click','li', function(ev) {
  $('#suburb').slideUp();
  var selectedLoc = $(this).text().split(',');
  $('#postcode1').val($(this).text());
  var selectedSuburb = selectedLoc[0].replace(/ /gi, "+");
  var selectedPostcode = selectedLoc[2];

  $('#productId').attr('data-postcode', selectedPostcode);
  $('#productId').attr('data-suburb', selectedSuburb);
}); 

// Postage calculator #04 (click go)
$('#deliverytrigger1').click(function(ev){
    ev.preventDefault();
    if ($('#postcode1').val() != "") {
        $('.check-result-container').slideUp('fast');
        var postcode = $('#productId').attr('data-postcode').replace(' ', '');
        var suburb = $('#productId').attr('data-suburb');
        if ($('.this-is-cart-page').length != 0 ) {
            var sku = $('#allsku').attr('data-sku');
        } else {
            var sku = $('.sku').text();
        }
        if ($('#postcode1').val().split(',')[0].replace(/ /gi, "+") == suburb) {
            postageCalc(postcode, suburb, sku);
        }
    }
});

// Postage calculator #05 (ajax call...)
function postageCalc(postcode, suburb, sku){
    var url = 'https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=712&deploy=1&compid=1117015&ns-at=AAEJ7tMQmWDVLsk37sTXyeC7k2gKi91BwzdlLcYf8Y9arlMnQew&postcode='+postcode+'&suburb='+suburb+'&item_sku='+sku+'&source=activego-global';
    $.ajax({
      url: url,
      type: "get",
      crosscallDomain: true,
      dataType: "jsonp",
      beforeSend: function(xhr) {
        $('.spinner-1').show(); 
      }
    }).done(function(data) {
        if (data.error.length >= 1) {
            $('.spinner-1').hide();
            $('.delivery-pickup-input').hide();
            $('.delivery-pickup').append('<p class="text-danger fs-12">'+data.error+'</p>');
        } else{
            updatePrice(data.uniq_rates);
        }
    }).fail(function() {
        $('#postage-results').html('Unkown errors, please try again later!');
    })
}

// Postage calculator #06 (display price)
function updatePrice(all_rates){
    if (all_rates === undefined == false ) {
        jQuery(window).trigger('resize').trigger('scroll');
        $('.spinner-1').show();

        // Prices
        $('.delivery-check-result').show();
        $('.delivery-check-result .rate').html("Not Available");
        $('.delivery-check-result #regular').html("Please contact us for a quote");
        // Update cart page
        $('.default-hide.cart-page').hide();

        $('#noprice').hide();
        // Jason files sourced from LSF, don't forget to update the version
        $.getJSON("https://cdn.shopify.com/s/files/1/0104/9926/0474/t/27/assets/delivery-informations-2022.json", function (result){
            //console.log(result)
            $( ".delivery-info" ).each(function() {
               var classData = $(this).attr('data-deliveryinfo');
               console.log(classData)
               $( ".delivery-info."+classData + ' ul').html(result[classData].includes.join(""));
               result[classData].additional_info != "" && $( ".delivery-info."+classData + ' ul').append(result[classData].additional_info);
            });

            // Display prices
            for (var i = 0; i < all_rates.length; i++) {
                var idPrices = all_rates[i].type.replace(/\|/g, '_');

                //re-display cart delivery option in cart page
                $('.cart-page.'+idPrices).show();
                if (all_rates[i].total_price == 0) {
                    $('.delivery-check-result #'+idPrices).html(result[idPrices].if_zero);
                } else {
                    var ratedelivery = all_rates[i].total_price.toFixed(2);
                    $('.delivery-check-result #'+idPrices).html("$" + ratedelivery);
                }
                if (all_rates[i].type == 'pickup') {
                    // Get exact location NSW or VIC for pikcup
                    var pickupLoc = all_rates[i].display_code.split('@');
                    $("#pickupLoc").html(pickupLoc[1]);
                    if (all_rates[i].carrier_name == "Pickup NSW" || all_rates[i].carrier_name == "Pickup VIC") {
                        $('.pickup-container').hide();
                    } else {
                        $('.pickup-container').show();
                    }
                }
            }
        });
    } else {
        $('.delivery-check-result').hide();
        $('.check-result-container').append('<p id="noprice" style="font-size:13px;">Please contact us via online chat or phone for a tailored shipping quote. </p>');
    }
    $('.spinner-1').hide();
    $('.check-result-container').slideDown('slow');
    $('.delivery-pickup-input').hide();
    $('#delivery-loc').text($('#postcode1').val());
}



$(".trg-d").on('click', function(ev) {
    ev.preventDefault();
    $('.check-result-container').hide();
    $('.delivery-pickup-input').show();
    $('#postcode1').val('');
})

$('.scroll-to').click(function(ev){
    ev.preventDefault();
    var target = $(this).attr('data-target');
    var space = parseInt($(this).attr('data-top'));
    $(this).parents('li').siblings().removeClass('active');
    $(this).parents('li').addClass('active');
    $('html, body').animate({
        scrollTop: $(target).offset().top - space
    }, 1500)
});

$('.open-search-mob').click(function(ev){
    ev.preventDefault();
    console.log('clicked');
    $('.mobile-nav-item.mobile-nav-search').slideToggle('fast')
})

















